import React, { useState, useEffect, useMemo } from "react";
import { Autocomplete, TextField } from "@mui/material";
import axios from "axios";
import { fetchCountry } from "../../lib/api_routes/country";

export const CountryDropDown = ({
  value,
  onChange,
  error,
  helperText,
  required = false,
  accountCountries = [],
  accoundId,
  ...otherProps
}) => {
  const [allCountries, setAllCountries] = useState([]);

  //Fetch countries api
  useEffect(() => {
    async function fetchCountriesFromBackend() {
      try {
        const data = await fetchCountry();

        if (Array.isArray(data.countries) && data.countries.length > 0) {
          const sortedCountries = data.countries.sort();
          setAllCountries(sortedCountries);
        } else {
          await fetchCountriesIfNoResults();
        }
      } catch (error) {
        console.error("Error fetching the country data:", error);
      }
    }
    async function fetchCountriesIfNoResults() {
      try {
        const response = await axios.get(`https://restcountries.com/v3.1/all`);
        const sortedCountries = response.data
          .map((country) => country.name.common)
          .sort();
        setAllCountries(sortedCountries);
      } catch (error) {
        console.error("Error fetching the country data:", error);
      }
    }
    fetchCountriesFromBackend();
  }, []);

  return (
    <Autocomplete
      options={allCountries}
      value={value || ""}
      onChange={(event, newValue) => {
        if (onChange) {
          onChange(newValue || "");
        }
      }}
      freeSolo
      // Filter the options based on the first characters
      filterOptions={(options, { inputValue }) => {
        return options.filter((country) =>
          country.toLowerCase().startsWith(inputValue.toLowerCase()),
        );
      }}
      slotProps={{
        clearIndicator: {
          sx: {
            color: "primary.brandSecondary",
            backgroundColor: "primary.white",
            "&:hover": {
              backgroundColor: "primary.main",
              color: "primary.brandSecondary",
            },
          },
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Country"
          placeholder="Please select a country"
          size="small"
          variant="outlined"
          required={required}
          error={error}
          helperText={helperText}
          sx={{ mb: 0.5 }}
        />
      )}
    />
  );
};
